import React, { useContext, useEffect, Fragment } from "react";
import LoadingComponent from "../../app/layout/LoadingComponent";
import CalculatorStore from "../../app/stores/calculatorStore";
import { observer } from "mobx-react-lite";
import CalculatorForm from "./CalculatorForm";

const Calculator: React.FC = () => {
  const calculatorStore = useContext(CalculatorStore);

  useEffect(() => {
    calculatorStore.loadPrices();
  }, [calculatorStore]);

  if (calculatorStore.loadingInitial)
    return <LoadingComponent content="Carregando..." />;

  return (
    <Fragment>
        <CalculatorForm />
    </Fragment>
  );
};

export default observer(Calculator);
